import { useEffect } from "react";
import { initMetaPixel, trackPageView } from "../utils/metaPixel";

export function useMetaPixel() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
}
